export default "/images/vendor/flag-icon-css/flags/1x1/mu.svg?fd1c498d09f3df7291e331e939f3ea78";